import {
    GET_TRANSACTION_INSTALLMENT_TYPE_DEF,
    GET_TRANSACTION_INSTALLMENT_TYPE_DEF_SUCCESS,
    TRANSACTION_INSTALLMENT_TYPE_DEF_API_ERROR
} from "./actionTypes"

export const getTransactionInstallmentTypeDefList = () => ({
    type: GET_TRANSACTION_INSTALLMENT_TYPE_DEF
})

export const getTransactionInstallmentTypeDefListSuccess = record => ({
    type: GET_TRANSACTION_INSTALLMENT_TYPE_DEF_SUCCESS,
    payload: record
})

export const apiTransactionInstallmentTypeDefApiError = error => ({
    type: TRANSACTION_INSTALLMENT_TYPE_DEF_API_ERROR,
    payload: error
})